import { Injectable, inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CustomerService } from '@marina/api-client';
import { AuthService } from '@marina/auth';

@Injectable({
  providedIn: 'root',
})
export class OnboardingGuard implements CanActivate {
  private router = inject(Router);
  private customerService = inject(CustomerService);
  private authService = inject(AuthService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // Check if user is authenticated
    const currentUser = this.authService.currentUserValue;
    if (!currentUser) {
      this.router.navigate(['/auth/login']);
      return of(false);
    }

    // Dockhands are linked to an owner account — skip owner onboarding; use dashboard role.
    return this.customerService.getDashboard().pipe(
      map((dashboard) => {
        const role = (dashboard.portalRole ?? '').toString().toLowerCase();
        if (role === 'dockhand') {
          return true;
        }

        if (dashboard.customer?.isOnboardingRequired) {
          this.router.navigate(['/onboarding']);
          return false;
        }

        return true;
      }),
      catchError((error) => {
        console.error('Error checking onboarding status:', error);
        return of(true);
      })
    );
  }
}
